import { useTheme, type Theme } from '@mui/material/styles';
import { observer } from 'mobx-react';

import { CriteriaTooltip } from '@/components/boxes/common/Criteria/CriteriaTooltip.tsx';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import type { FC } from 'react';
import type { FlagMeasurementProps } from '@/components/boxes/measurementBoxes/FlagMeasurementBox/FlagMeasurementBox.tsx';
import { useCriteria } from '../../common/Criteria/useCriteria';
import { CriteriaTableCell } from '../../common/Criteria/CriteriaTableCell/CriteriaTableCell';
import { getConditionalMeasurementColor } from '../../styles';

interface Props {
  measurement: FlagMeasurementProps;
  hasCriteria: boolean | undefined;
  index: number;
}

interface FlagMeasurementPropsDetails {
  label: string | Array<{ text: string; icon?: 'success' | 'error' | 'warning' }> | undefined;
}

export const FlagMeasurementRow: FC<Props> = observer(({ measurement, hasCriteria, index }) => {
  const theme: Theme = useTheme();

  const label = (measurement.details as FlagMeasurementPropsDetails | undefined)?.label;

  const { criteriaStatus } = useCriteria(measurement.descriptor);

  return (
    <CriteriaTooltip title={hasCriteria && criteriaStatus !== undefined ? label : undefined}>
      <TableRow
        key={index}
        data-testid={'flagCriteria'}
        sx={{
          '&:last-child td': { border: 0 }
        }}
      >
        <CriteriaTableCell criteriaStatus={hasCriteria ? criteriaStatus : undefined} index={index} />
        <TableCell
          component="td"
          scope="row"
          colSpan={3}
          sx={{
            paddingLeft: 0,
            color: getConditionalMeasurementColor(hasCriteria, criteriaStatus, theme)
          }}
        >
          {measurement.label}
        </TableCell>
        <TableCell
          component="td"
          scope="row"
          align={'right'}
          sx={{
            color: getConditionalMeasurementColor(hasCriteria, criteriaStatus, theme)
          }}
        >
          {criteriaStatus === undefined ? '-' : criteriaStatus === 'success' ? 'Yes' : 'No'}
        </TableCell>
      </TableRow>
    </CriteriaTooltip>
  );
});
